import { type JSX,MouseEventHandler } from 'react';

import CircleIcon from '@mui/icons-material/Circle';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ReactComponent as FilterIcon } from 'assets/icons/Icon-Filter-Teal.svg';

type FilterButtonProps = {
    onClickHandler?: MouseEventHandler<HTMLButtonElement>;
    isFilterApplied: boolean;
};

export function FilterButton({
    onClickHandler,
    isFilterApplied
}: Readonly<FilterButtonProps>): JSX.Element {
    const theme = useTheme();

    const appliedFilterIcon = isFilterApplied && (
        <CircleIcon
            fontSize={'small'}
            sx={{
                position: 'absolute',
                bottom: '22px',
                left: '24px',
                fontSize: '1.2rem'
            }}
            className='circle-icon'
        />
    );

    return (
        <Button
            onClick={onClickHandler}
            sx={{
                padding: '4px',
                minWidth: 'auto',
                marginRight: '1.5rem',
                border: isFilterApplied ? 1 : null,
                backgroundColor: isFilterApplied ? 'primary.ultraLight' : 'transparent' ,
            }}
        >
            <FilterIcon data-testid="Icon-Filter-Teal" style={{ color: theme.palette.primary.accent }} />
            {appliedFilterIcon}
        </Button>
    );
}
